import { Injectable } from '@angular/core';
import { RequestBuilderService } from '@klickdata/core/http/src/request/request-builder.service';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    constructor(protected builder: RequestBuilderService) { }

    public download(url: string, params: { [key: string]: (number | string)[] }): Observable<Blob> {
        const builder = this.builder.get<Blob>(url);
        for (const key in params) {
            builder.param(key, params[key].join());
        }
        return builder.download();
    }

    public getDownloadUrl(url: string, params: { [key: string]: (number | string)[] }): Observable<{ download_url: string, file_name: string, messages: string[] }> {
        const builder = this.builder.get<{ download_url: string, file_name: string,messages: string[] }>(url);
        for (const key in params) {
            builder.param(key, params[key].join());
        }
        return builder.request().pipe(
            map((response) => {
                return {
                    download_url: response.data.download_url,
                    file_name: response.data.file_name,
                    messages: response.data.messages,
                };
            })
        );
    }
}
